import React, { Component } from "react";
import CommissionPaymentForm from "../components/Comision_Multi/CommissionPaymentForm";

class MultiCom extends Component {
    render(){
        return(
            <div>
            <CommissionPaymentForm/>
            </div>
        )
    }

} export default MultiCom